import { LitElement, html, css } from 'lit';

class AppShell extends LitElement {
  static properties = {
    _scrolled: { type: Boolean, state: true },
    _contactOpen: { type: Boolean, state: true },
  };

  static styles = css`
    :host {
      display: block;
      min-height: 100vh;
    }
    main {
      width: 100%;
    }
  `;

  constructor() {
    super();
    this._scrolled = false;
    this._contactOpen = false;
    this._onScroll = this._onScroll.bind(this);
    this._onOpenContact = this._onOpenContact.bind(this);
  }

  connectedCallback() {
    super.connectedCallback();
    window.addEventListener('scroll', this._onScroll, { passive: true });
    window.addEventListener('open-contact', this._onOpenContact);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('scroll', this._onScroll);
    window.removeEventListener('open-contact', this._onOpenContact);
  }

  _onScroll() {
    this._scrolled = window.scrollY > 50;
  }

  _onOpenContact() {
    this._contactOpen = true;
  }

  render() {
    return html`
      <metalyx-nav ?scrolled="${this._scrolled}"></metalyx-nav>
      <main>
        <metalyx-page></metalyx-page>
      </main>
      <metalyx-footer></metalyx-footer>
      <metalyx-contact-modal
        ?open="${this._contactOpen}"
        @close="${() => this._contactOpen = false}"
      ></metalyx-contact-modal>
    `;
  }
}

customElements.define('app-shell', AppShell);